import {
    Button,
    SIZE_BLOCK,
    SIZE_RESPONSIVE,
    STYLE_FILL,
    STYLE_NEUTRAL,
    STYLE_REBRANDING_FILL,
    STYLE_REBRANDING_NEUTRAL,
    TYPE_BUTTON,
} from '@eventbrite/eds-button';
import { GenericLazyString } from '@eventbrite/i18n';
import classNames from 'classnames';
import React from 'react';
import {
    DEFAULT_STYLES,
    getStyles,
    REBRANDING_STYLES,
} from '../../utils/rebrand';
import defaultStyles from './ConfirmDialog.module.scss';
import rebrandStyles from './ConfirmDialog.rebranding.module.scss';

const stylesModules = {
    [DEFAULT_STYLES]: defaultStyles,
    [REBRANDING_STYLES]: rebrandStyles,
};

export interface ConfirmDialogProps {
    infoMessage?: GenericLazyString;
    isAppRebrandActive: boolean;
    confirmButtonText: GenericLazyString;
    cancelButtonText: GenericLazyString;
    onCancelButtonClick: () => void;
    onConfirmButtonClick: () => void;
}

export const ConfirmDialog: React.FunctionComponent<ConfirmDialogProps> = ({
    cancelButtonText,
    confirmButtonText,
    infoMessage,
    isAppRebrandActive,
    onCancelButtonClick,
    onConfirmButtonClick,
}) => {
    const theme = getStyles(isAppRebrandActive);
    const styles = stylesModules[theme];

    const wrapperClassname = classNames({
        'eds-g-grid eds-l-pad-bot-2': !isAppRebrandActive,
        [styles.wrapper]: isAppRebrandActive,
    });

    const infoMessageClassname = classNames({
        'eds-l-pad-bot-6': !isAppRebrandActive,
        'eds-l-pad-bot-4': isAppRebrandActive,
    });

    const buttonWrapperClassname = classNames({
        'eds-g-cell eds-g-cell-6-12 eds-l-pad-hor-2': !isAppRebrandActive,
    });

    const buttonSize = isAppRebrandActive ? SIZE_RESPONSIVE : SIZE_BLOCK;

    return (
        <div className={styles.root}>
            <div
                data-spec="confirm-widget-info-message"
                className={infoMessageClassname}
            >
                {infoMessage}
            </div>
            <div className={wrapperClassname}>
                <div className={buttonWrapperClassname}>
                    <Button
                        data-spec="confirm-widget-cancel-button"
                        type={TYPE_BUTTON}
                        onClick={onCancelButtonClick}
                        style={
                            isAppRebrandActive
                                ? STYLE_REBRANDING_NEUTRAL
                                : STYLE_NEUTRAL
                        }
                        size={buttonSize}
                        data-automation="checkout-widget-return-to-checkout-button"
                    >
                        {cancelButtonText}
                    </Button>
                </div>
                <div className={buttonWrapperClassname}>
                    <Button
                        data-spec="confirm-widget-confirm-button"
                        type={TYPE_BUTTON}
                        style={
                            isAppRebrandActive
                                ? STYLE_REBRANDING_FILL
                                : STYLE_FILL
                        }
                        size={buttonSize}
                        onClick={onConfirmButtonClick}
                        data-automation="checkout-widget-leave-checkout-button"
                    >
                        {confirmButtonText}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmDialog;
